export enum TableShapeDTO {
    RECTANGULAR = 'RECTANGULAR',
    ROUND = 'ROUND'
}
